<template>
  <modal name="initPasswordPopup" :width="0" :height="0" :clickToClose="false"
      @before-open="beforeOpen"
      @opened="opened">

  <div class="popup" id="pw_find">
    <div class="prePop">
      <div class="prePop_wrap">
        <div class="prePop_contents">
          <div class="prePop_cont_area">
            <div class="prePop_top">
              <p class="popt">비밀번호 초기화</p>
              <p class="popimg02"></p>
            </div>
            <div class="id_pop_contents">
              <div class="login_id_form mt10">
                <div class="login_phone tal">
                  <input type="text" name="아이디" placeholder="아이디" class="w80-p" v-model="form.loginId" v-validate="'required'">
                  <div class="lo_validation" v-if="errors.has('아이디')">
                    <div class="lo_tri"></div>
                      <span>{{ errors.first('아이디') }}</span>
                  </div>    
                </div>
              </div>
              <div class="mt10">
                <div class="phonenum_btn">
                  <button @click="getAuthNumber"><span>인증번호 받기</span></button>
                </div>
              </div>
              <div class="login_id_form mt10">
                <div class="login_phone tal">
                  <input type="text" name="폰인증번호"  placeholder="폰인증번호 입력" class="w80-p" v-model="form.authNumber" v-validate="'required'">
                  <div class="validation" v-if="errors.has('폰인증번호')">
                    <div class="lo_tri"></div>
                      <span>{{ errors.first('폰인증번호') }}</span>
                  </div>
                  <timeCounter ref="pwdTimeCounter" :startTime="authNumberTime" />
                  <!-- <button><span>인증</span></button> -->
                </div>
              </div>
            </div>
            <div class="prePop_txt" @click="initPassword">
              <div class="prePopfooter">
                <div class="cell">
                  <a href="javascript:void(0)">확인</a>
                </div>
              </div>
            </div>
          </div>
          <a href="javascript:void(0);" class="btn_prePop_close" title="닫기" @click="close">닫기</a>
        </div>
      </div>
    </div>
  </div>

  </modal>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'
import TimeCounter from '@/components/TimeCounter'
import Utils from '@/modules/utils'

export default {
  name: 'initPasswordPopup',
  components: { TimeCounter },
  data: () => ({
    form: {
      loginId: '',
      authNumber: ''
    },
    authNumberTime: 180
  }),  
  methods: {
    beforeOpen(e) {

      // 파라미터 초기화
      Utils.initObject(this.form, false);      

    },
    opened(e) {  
    },
    getAuthNumber () {
      if (this.form.loginId == null || this.form.loginId == '') { 
        Vue.Alert.alert('먼저 아이디를 입력하십시오.');
        return; 
      }

      // 인증번호 전송 요청
      Vue.httpClient
      .post(AppConfig.HTTP_CONFIG.authURL + '/authnumber', this.form)
      .then((response) => {
        if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
          if ( response.data.result != undefined ) {
            Vue.Alert.alert(response.data.result);
          }

          this.$refs.pwdTimeCounter.startCounter();
        }  
      })
      .catch(e => {
        if (e.result.status == AppConfig.NO_ID) {
          Vue.Alert.alert('존재하지 않는 ID 입니다.');
        }
      })             
    },    
    initPassword() {
      this.$validator.validateAll()
        .then((success) => {
          if (!success) { return; }

          // 비밀번호 초기화
          Vue.httpClient
          .post(AppConfig.HTTP_CONFIG.authURL + '/login/password/initialize', this.form)
          .then((response) => {
            if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
              if ( response.data.result != undefined ) {
                Vue.Alert.alert(response.data.result);
              }

              this.$modal.hide('initPasswordPopup');
            } 
          })
          .catch(e => {
            if (e.result.status == AppConfig.AUTH_NUMBER_FAIL) {
              Vue.Alert.alert('인증번호를 잘못 입력하셨습니다.');
            }
          })           
        });
    },
    close() {
      this.$modal.hide('initPasswordPopup');
    }    
  }
}
</script>


// WEBPACK FOOTER //
// src/views/common/InitPasswordPopup.vue